import React from 'react';
import PropTypes from 'prop-types';
import ServerTimeLeft from './server-time-left';

import { getTimeSpanParts, TIME_SPAN_UNITS } from 'tradera-utils/date';
import { useTranslator } from 'tradera-lang/translate';

const TIME_LEFT_DAY_LIMIT = 24 * 60 * 60;
const TIME_LEFT_HOUR_LIMIT = 60 * 60;
const TIME_LEFT_MINUTE_LIMIT = 60;

const TIME_LEFT_WARNING_LIMIT = 4 * 60 * 60;

function TimeLeft(props) {
    const {
        className = '',
        isCountdownEnabled,
        serverSecondsLeft,
        icon,
        seconds,
        ...otherProps
    } = props;
    const { t } = useTranslator();

    if (!isCountdownEnabled)
        return <ServerTimeLeft seconds={serverSecondsLeft} />;

    const timeLeftWarning = seconds <= TIME_LEFT_WARNING_LIMIT;
    return (
        seconds >= 0 && (
            <span
                data-test-time-left
                className={`${
                    timeLeftWarning ? 'text-danger' : ''
                } ${className}`}
                {...otherProps}>
                {icon}
                {seconds > 0 ? formatTimeSpan(seconds, t) : t('vip_ended')}
            </span>
        )
    );
}

const hoursOrEmpty = (hours, t) =>
    hours ? t('vip_hours', { count: hours }) : '';

const minutesOrEmpty = (minutes, t) =>
    minutes ? t('vip_minutes', { count: minutes }) : '';

function formatTimeSpan(secondsLeft, t) {
    if (secondsLeft < 1) {
        return '';
    }
    let formattedTimeLeft;
    if (secondsLeft > TIME_LEFT_DAY_LIMIT) {
        const { days, hours } = getTimeSpanParts(secondsLeft, {
            endUnit: TIME_SPAN_UNITS.HOURS
        });
        formattedTimeLeft =
            t('vip_days', { count: days }) + ' ' + hoursOrEmpty(hours, t);
    } else if (secondsLeft > TIME_LEFT_HOUR_LIMIT) {
        const { hours, minutes } = getTimeSpanParts(secondsLeft, {
            startUnit: TIME_SPAN_UNITS.HOURS,
            endUnit: TIME_SPAN_UNITS.MINUTES
        });
        formattedTimeLeft =
            t('vip_hours', { count: hours }) + ' ' + minutesOrEmpty(minutes, t);
    } else if (secondsLeft > TIME_LEFT_MINUTE_LIMIT) {
        const { minutes, seconds } = getTimeSpanParts(secondsLeft, {
            startUnit: TIME_SPAN_UNITS.MINUTES,
            endUnit: TIME_SPAN_UNITS.SECONDS
        });
        formattedTimeLeft =
            t('vip_minutes', { count: minutes }) +
            ' ' +
            t('vip_seconds', { count: seconds || 0 });
    } else {
        formattedTimeLeft = t('vip_seconds', { count: secondsLeft });
    }
    return formattedTimeLeft;
}

TimeLeft.propTypes = {
    seconds: PropTypes.number.isRequired,
    serverSecondsLeft: PropTypes.number,
    isCountdownEnabled: PropTypes.bool.isRequired
};

export default TimeLeft;
